

























import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class DataTable extends Vue {
    // @Prop() private items!:any[];
    // @Prop() private colums!:any[];

    items:any[] = [];
    columns:any[] = [{dataColumn:"cardName", readerFriendy:"Kortnamn"}, {dataColumn:"jobName", readerFriendy:"Jobbnamn"}, {dataColumn:"status", readerFriendy:"Aktivitet"}, {dataColumn:"date", readerFriendy:"Datum"}];

    renderTable(items:any[]){
        console.log(items);
        this.items = items;
    }

    async created(){
    }
}
